import type { ObjectId } from '@vy/types';
import { extract } from '@vy/utils';
import { useMeters } from '../../../../../../hooks/requests/use-meters/use-meters';
import { VySelectField } from '../../../../../../design-system-adapters/forms';
import type { PlanInputForm } from '../../CreatePlanForm/create-plan-form-types/plan-input-form';
import type { FieldPath } from 'react-hook-form';

type ProductSourceSelectProps = {
  name: FieldPath<PlanInputForm>;
  selectedMetersIds?: string[];
  label?: string;
};

export const ProductSourceSelect: React.FC<ProductSourceSelectProps> = ({
  name,
  selectedMetersIds,
  label = 'Select product source',
}) => {
  const {
    data: { meters },
  } = useMeters();

  const filteredMeters = selectedMetersIds
    ? meters.filter(({ id }) => !selectedMetersIds.includes(id))
    : meters;

  const meterIds = extract(filteredMeters, 'id') as ObjectId[];

  const getOptionLabel = (option: ObjectId): string =>
    meters.find(({ id }) => id === option)?.name ?? '';

  return (
    <VySelectField<PlanInputForm, ObjectId>
      name={name}
      label={label}
      placeholder="Product source"
      options={meterIds}
      getOptionLabel={getOptionLabel}
      autoHighlight
      data-vy="plan-charge-drawer-product-source"
    />
  );
};
